/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useSearchParams } from 'react-router';

import { useAuthModalScreen } from '../AuthModalScreenContext';
import { RequestPasswordResetForm } from './RequestPasswordResetForm';
import { EmailCodeAndNewPasswordForm } from './EmailCodeAndNewPasswordForm';
import { PasswordSavedSuccess } from '../components/PasswordSavedSuccess';

export function ForgotPasswordForms() {
    const { setScreen } = useAuthModalScreen();
    const [searchParams, setSearchParams] = useSearchParams();
    const authStep = searchParams.get('authStep');
    const emailAddress = searchParams.get('authEmail');

    const onEmailSent = (email: string) => {
        setSearchParams((prev) => {
            prev.set('auth', 'requestPasswordReset');
            prev.set('authStep', 'verify');
            prev.set('authEmail', email);
            return prev;
        });
    };

    const onResendEmailClick = () => {
        setSearchParams((prevParams) => {
            prevParams.delete('authStep');
            prevParams.delete('authEmail');
            return prevParams;
        });
    };

    const transitionToMfaCodeScreen = () => {
        setSearchParams((prevParams) => {
            prevParams.set('auth', 'mfaCode');
            prevParams.delete('authStep');
            prevParams.delete('authEmail');
            return prevParams;
        });
        setScreen('mfaCode');
    };

    const transitionToSuccessScreen = () => {
        setSearchParams((prevParams) => {
            prevParams.set('authStep', 'success');
            prevParams.delete('authEmail');
            return prevParams;
        });
    };

    const transitionToLoginScreen = () => {
        setSearchParams((prevParams) => {
            prevParams.delete('auth');
            prevParams.delete('authStep');
            prevParams.delete('authEmail');
            return prevParams;
        });
        setScreen('login');
    };

    return (
        <div>
            {authStep === 'verify' && emailAddress ? (
                // step 2
                <EmailCodeAndNewPasswordForm
                    emailAddress={emailAddress}
                    onResendEmailClick={onResendEmailClick}
                    transitionToMfaCodeScreen={transitionToMfaCodeScreen}
                    transitionToSuccessScreen={transitionToSuccessScreen}
                />
            ) : authStep === 'success' ? (
                // step 3
                <PasswordSavedSuccess transitionToLoginScreen={transitionToLoginScreen} />
            ) : (
                // step 1
                <RequestPasswordResetForm
                    onEmailSent={onEmailSent}
                    onLogInClick={() => {
                        setScreen('login');
                    }}
                />
            )}
        </div>
    );
}
